import { Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import React, { useState } from "react";
import { FormBox, Span, TextButton, TextLabel, TextValue } from "../../styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../../Infrastructure/config";
import { ShowErrorToast, ShowSuccessToast } from "../../../Common/Toast/toast";
import { useSelector } from "react-redux";
import ButtonLoading from "../../../Common/Button/ButtonLoading";
import { trackEvent } from "../../../../Infrastructure/Utilities/analytics";
import useAuthentication from "../../../../Infrastructure/States/onAuthStateChange";
import AnalyticsConstants from "../../../../Infrastructure/Constants/AnalyticsContants";
import ERROR_CONSTANTS from "../../../../Infrastructure/Constants/errorConstants";
import { USER_LOGS_CLIENT } from "../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../Infrastructure/Utilities/safeClientLogEvent";
import {
  StyledTextField,
} from "../../../../Infrastructure/Theme/styledComponents";
import numberBoxSx from './styles';

export const NumberBox = ({ handleOpen, handleClose, showEditNumber }) => {
  const { userId } = useAuthentication();
  const [loading, setLoading] = useState(false)
  const ip = useSelector((state) => state.ip.address)
  const page = useSelector((state) => state.route.currentRoute)
  const userData = useSelector((state) => state.userData.data);
  const number = userData?.account?.number;
  const numberFormik = useFormik({
    initialValues: {
      number: number || "",
    },
    validationSchema: Yup.object({
      number: Yup.string()
        .matches(/^[0-9]+$/, "Phone number must be digits only")
        .required("Phone number is required"),
    }),
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting,  resetForm }) => {
      try {
        setLoading(true)
        const { number } = values;
        if (!numberFormik.isValid) {
          return;
        }
        const updateProfile = httpsCallable(functions, "updateaccount");
        const requestData = {
          ip,
          page,
          number: number,
        };
        await updateProfile(requestData);
        ShowSuccessToast("Phone Number updated successfully.", {position: "top-center"})
        // Track event without blocking form submission
       try{
         trackEvent(AnalyticsConstants.PHONE_NUMBER_CHANGED, { user_id: userId })
      }catch(trackingError) {
         await safeClientLogEvent({
            ...USER_LOGS_CLIENT.TRACKING_EVENT_FAILED,
            uid: userId || null,
            source: "numberBox.jsx",
            emailInfo: null,
            metadata: null,
            error: trackingError?.message || null
          });
      }
        handleClose();
        resetForm()
      } catch (error) {
        await safeClientLogEvent({
          ...USER_LOGS_CLIENT.ACCOUNT_NUMBER_UPDATE_FAILED,
          uid: userId || null,
          source: "numberBox.jsx",
          emailInfo: null,
          metadata: { number: `${numberFormik?.values?.number}` } || null,
          error: error?.message || null
        });
        ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST, {position: "top-center"})
      } finally {
        setSubmitting(false);
        setLoading(false)
      }
    },
  });
  return (
    <>
      {number && (
        <Box mx={3}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={numberBoxSx.stackSx}
          >
            <TextLabel>Phone Number</TextLabel>
            <TextValue>{number}</TextValue>
            {!showEditNumber ? (
              <Span
                direction="row"
                alignItems={"center"}
                onClick={() => handleOpen({ prop: "number" })}
              >
                <TextButton curser="pointer">Edit</TextButton>
                <KeyboardArrowDownIcon fontSize="small" color="primary" />
              </Span>
            ) : (
              <Span
                direction="row"
                alignItems={"center"}
                onClick={() => {
                  numberFormik.resetForm();
                  handleClose();
                }}
              >
                <TextButton curser="pointer">Edit</TextButton>
                <KeyboardArrowUpIcon fontSize="small" color="primary" />
              </Span>
            )}
          </Stack>
          {showEditNumber && (
            <Box>
              <FormBox
                component="form"
                onSubmit={numberFormik.handleSubmit}
                noValidate
              >
                <Grid container>
                  <Grid lg={5} md={12} sm={12} xs={12}>
                    <Box sx={numberBoxSx.textFieldBoxSx}>
                      <StyledTextField
                        name="number"
                        label="Phone Number"
                        variant="standard"
                        onChange={numberFormik.handleChange}
                        value={numberFormik.values.number}
                        onBlur={numberFormik.handleBlur}
                        error={
                          numberFormik.touched.number &&
                          Boolean(numberFormik.errors.number)
                        }
                        InputProps={{
                          inputMode: "numeric",
                          onKeyPress: (event) => {
                            if (isNaN(event.key)) {
                              event.preventDefault();
                            }
                          },
                        }}
                        fullWidth
                      />
                    </Box>
                  </Grid>
                  <Grid lg={7}></Grid>
                </Grid>
                <Grid container mt={3}>
                  <Grid lg={2} md={2} sm={6} xs={6}>
                    <Box
                      sx={numberBoxSx.buttonBoxSx}
                    >
                      <Button 
                      variant="contained"
                      onClick={() => {
                          handleClose()
                          numberFormik.resetForm()
                        }}>
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                  <Grid lg={2} md={2} sm={6} xs={6}>
                    <Box
                      sx={numberBoxSx.buttonBoxSx}
                    >
                      <ButtonLoading text={"Update"} loading={loading} type={"submit"} />
                    </Box>
                  </Grid>
                  <Grid lg={6} md={6} sm={6} xs={6}></Grid>
                </Grid>
              </FormBox>
            </Box>
          )}
          <hr />
        </Box>
      )}
    </>
  );
};
